import React, { FunctionComponent } from 'react'
import { Box, SxStyleProp } from 'theme-ui'

import theme from '../../gatsby-plugin-theme-ui'
const { colors } = theme

import { useTone } from '../../hooks/useTone'

interface IThemeUIBumProps {
  /** Theme UI JSX pragma */
  sx?: SxStyleProp
}

export const ThemeUIBum: FunctionComponent<IThemeUIBumProps> = ({ sx }) => {
  const tone = useTone()
  return (
    <Box sx={{ width: '100%', height: 'auto', ...sx }}>
      <svg version="1.0" x="0px" y="0px" viewBox="0 0 400 180" width="100%" height="100%">
        <ellipse fill={colors.shadowBlue} cx="259.8" cy="157.9" rx="134.2" ry="15.8" />
        <ellipse fill={colors.shadowBlue} cx="105.1" cy="138.1" rx="93.1" ry="11.3" />
        <g>
          <g>
            <path
              fill={colors.text}
              d="M77.8,142c-0.2,0-0.4,0-0.6,0c-0.2,0-0.3,0-0.6,0H39.7c-4.6,0-8.6-3.3-9.7-7.7c-0.1-0.3-0.3-0.6-0.3-0.8
			L6.4,51.3c-1.4-5,1.5-10.3,6.5-11.7c0.8-0.3,1.7-0.3,2.6-0.3c0.5,0,1,0,1.5,0.1h104.9c0.5-0.1,1-0.1,1.5-0.1
			c4.3,0,7.9,2.8,9.1,6.8l21.7,76h30.5c5.5,0,9.9,4.4,9.9,9.9s-4.4,9.9-9.9,9.9H77.8L77.8,142z M76.7,122.2c0.2,0,0.4,0,0.6,0
			c0.2,0,0.3,0,0.6,0h56.6l-17.9-62.9H28.3l17.9,62.9H76.7z"
            />
            <path
              fill={colors.text}
              d="M143.6,132.3H42.3c-2.2,0-4.4-2-5.2-4.5L16.5,53.9c-0.8-2.5,0.4-4.5,2.5-4.5h101.3c2.2,0,4.4,2,5.2,4.5
			l20.6,73.9C146.9,130.3,145.8,132.3,143.6,132.3z"
            />
            <path
              fill="#A7A6A6"
              d="M184.6,128.8h-35.5l-23-80.8c-0.4-1.5-2-2.4-3.5-2c-0.1,0-0.1,0.1-0.2,0.1c-0.2,0-0.3-0.1-0.5-0.1H15.3
			c-0.3,0-0.6,0.1-0.8,0.2c0.8,2.1,1.3,4.3,1.5,6.5h105.5l22.5,79c0.1,0.3,0.2,0.4,0.3,0.7c0.2,1.7,1.6,3.1,3.3,3.1h37
			c1.8,0,3.3-1.5,3.3-3.3C187.8,130.3,186.3,128.8,184.6,128.8z"
            />
            <path
              fill="#A7A6A6"
              d="M184.3,135.4H77.8c-1.8,0-3.3-1.5-3.3-3.3l0,0c0-1.8,1.5-3.3,3.3-3.3h106.5c1.8,0,3.3,1.5,3.3,3.3l0,0
			C187.7,133.9,186.2,135.4,184.3,135.4z"
            />
            <path
              fill="#6D6D6C"
              d="M76.7,128.8H41.3L18.2,48c-0.4-1.5-2-2.4-3.5-2s-2.4,2-2,3.5l23.4,82.1c0.1,0.3,0.2,0.4,0.3,0.7
			c0.2,1.7,1.6,3.1,3.3,3.1h37c1.8,0,3.3-1.5,3.3-3.3C80,130.3,78.5,128.8,76.7,128.8z"
            />
            <g>
              <g>
                <path
                  fill={colors.primary}
                  d="M98.6,68.9H65.8c-0.8,0-1.8-0.7-2.1-1.6l0,0c-0.3-0.8,0.2-1.6,1-1.6h32.9c0.8,0,1.8,0.7,2.1,1.6l0,0
					C100,68.3,99.6,68.9,98.6,68.9z"
                />
              </g>
              <g>
                <path
                  fill={colors.secondary}
                  d="M55.8,77H40.1c-0.8,0-1.8-0.7-2.1-1.6l0,0c-0.3-0.8,0.2-1.6,1-1.6h15.7c0.8,0,1.8,0.7,2.1,1.6l0,0
					C57.1,76.4,56.7,77,55.8,77z"
                />
              </g>
              <g>
                <path
                  fill={colors.secondary}
                  d="M109.3,77H93.6c-0.8,0-1.8-0.7-2.1-1.6l0,0c-0.3-0.8,0.2-1.6,1-1.6h15.7c0.8,0,1.8,0.7,2.1,1.6l0,0
					C110.6,76.4,110.2,77,109.3,77z"
                />
              </g>
              <g>
                <path
                  fill={colors.secondary}
                  d="M87,77H61.3c-0.8,0-1.8-0.7-2.1-1.6l0,0c-0.3-0.8,0.2-1.6,1-1.6H86c0.8,0,1.8,0.7,2.1,1.6l0,0
					C88.4,76.4,87.9,77,87,77z"
                />
              </g>
              <g>
                <path
                  fill={colors.primary}
                  d="M117.1,85.4H58.8c-0.8,0-1.8-0.7-2.1-1.6l0,0c-0.3-0.8,0.2-1.6,1-1.6H116c0.8,0,1.8,0.7,2.1,1.6l0,0
					C118.4,84.6,117.9,85.4,117.1,85.4z"
                />
              </g>
              <g>
                <path
                  fill={colors.secondary}
                  d="M52.2,85.4h-9.5c-0.8,0-1.8-0.7-2.1-1.6l0,0c-0.3-0.8,0.2-1.6,1-1.6h9.6c0.8,0,1.8,0.7,2.1,1.6l0,0
					C53.6,84.6,53.2,85.4,52.2,85.4z"
                />
              </g>
              <g>
                <path
                  fill={colors.secondary}
                  d="M106.6,94.5H48.3c-0.8,0-1.8-0.7-2.1-1.6l0,0c-0.3-0.8,0.2-1.6,1-1.6h58.2c0.8,0,1.8,0.7,2.1,1.6l0,0
					C107.9,93.8,107.4,94.5,106.6,94.5z"
                />
              </g>
              <g>
                <path
                  fill={colors.secondary}
                  d="M81.5,102.7h-30c-0.8,0-1.8-0.7-2.1-1.6l0,0c-0.3-0.8,0.2-1.6,1-1.6h30c0.8,0,1.8,0.7,2.1,1.6l0,0
					C82.9,102.1,82.5,102.7,81.5,102.7z"
                />
              </g>
              <g>
                <path
                  fill={colors.secondary}
                  d="M118.1,102.7h-30c-0.8,0-1.8-0.7-2.1-1.6l0,0c-0.3-0.8,0.2-1.6,1-1.6h30c0.8,0,1.8,0.7,2.1,1.6l0,0
					C119.4,102.1,118.9,102.7,118.1,102.7z"
                />
              </g>
              <g>
                <path
                  fill={colors.secondary}
                  d="M63.5,111.8h-9.3c-0.8,0-1.8-0.7-2.1-1.6l0,0c-0.3-0.8,0.2-1.6,1-1.6h9.3c0.8,0,1.8,0.7,2.1,1.6l0,0
					C64.8,111.1,64.3,111.8,63.5,111.8z"
                />
              </g>
              <g>
                <path
                  fill={colors.primary}
                  d="M127.8,111.8H69.6c-0.8,0-1.8-0.7-2.1-1.6l0,0c-0.3-0.8,0.2-1.6,1-1.6h58.2c0.8,0,1.8,0.7,2.1,1.6l0,0
					C129.2,111.1,128.8,111.8,127.8,111.8z"
                />
              </g>
              <g>
                <path
                  fill={colors.secondary}
                  d="M115.3,120.2H57.1c-0.8,0-1.8-0.7-2.1-1.6l0,0c-0.3-0.8,0.2-1.6,1-1.6h58.2c0.8,0,1.8,0.7,2.1,1.6l0,0
					C116.7,119.4,116.2,120.2,115.3,120.2z"
                />
              </g>
              <g>
                <path
                  fill={colors.secondary}
                  d="M36.1,65.3c-0.1-0.3-0.1-0.5,0.2-0.7c1.8-1.3,2.8-2.1,3.3-2.4c0.1-0.1,0.2-0.1,0.3-0.2
					c0.1,0,0.2,0,0.3,0c0.1,0,0.2,0,0.3,0.1c0.1,0.1,0.3,0.2,0.4,0.3c0.2,0.2,0.3,0.3,0.3,0.4c0.1,0.1,0.1,0.2,0.1,0.3
					c0,0.1-0.1,0.2-0.1,0.2c0,0.1-0.1,0.1-0.2,0.2c-1.5,1.1-2.3,1.7-2.3,1.8l3.6,1.8c0.2,0.1,0.3,0.2,0.3,0.2
					c0.1,0.1,0.2,0.1,0.3,0.2s0.1,0.2,0.2,0.3c0,0.1,0,0.3-0.1,0.4c-0.1,0.2-0.1,0.3-0.2,0.3c-0.1,0.1-0.2,0.1-0.3,0.1
					c-0.1,0-0.2,0-0.3-0.1c-0.1,0-0.2-0.1-0.3-0.2L37,65.7C36.5,65.9,36.2,65.6,36.1,65.3z"
                />
                <path
                  fill={colors.secondary}
                  d="M47.2,68.7c0,0.1,0,0.2,0,0.3c0,0.1,0,0.1-0.1,0.2c-0.1,0.1-0.1,0.1-0.3,0.1c-0.2,0-0.3-0.1-0.6-0.2
					c-0.3-0.1-0.4-0.2-0.5-0.3c-0.1-0.1-0.2-0.2-0.2-0.3c0-0.1-0.1-0.3-0.1-0.5l0.8-6.4c0-0.1,0-0.2,0-0.2s0-0.1,0.1-0.2
					c0-0.1,0.1-0.1,0.1-0.1c0.1,0,0.1,0,0.2,0c0.2,0,0.3,0.1,0.6,0.2c0.4,0.2,0.7,0.3,0.7,0.6c0,0.1,0,0.3,0,0.5L47.2,68.7z"
                />
                <path
                  fill={colors.secondary}
                  d="M57.7,65.3c0.1,0.3,0.1,0.6-0.2,0.7l-3.3,2.4c-0.1,0.1-0.2,0.1-0.3,0.2c-0.1,0-0.2,0-0.3,0
					c-0.1,0-0.2,0-0.3-0.1c-0.1-0.1-0.3-0.2-0.4-0.3c-0.2-0.2-0.3-0.3-0.3-0.4c-0.1-0.1-0.1-0.2-0.1-0.3s0.1-0.2,0.1-0.2
					c0-0.1,0.1-0.1,0.2-0.2l2.3-1.8l-3.6-1.8c-0.2-0.1-0.3-0.2-0.3-0.2c-0.1-0.1-0.2-0.1-0.3-0.2c-0.1-0.1-0.1-0.2-0.2-0.3
					c0-0.1,0-0.3,0-0.4c0-0.2,0.1-0.3,0.2-0.3s0.2-0.1,0.3-0.1c0.1,0,0.2,0,0.3,0c0.1,0,0.2,0.1,0.3,0.2l4.9,2.4
					C57.3,64.8,57.6,65,57.7,65.3z"
                />
              </g>
            </g>
            <circle fill={colors.text} cx="44.2" cy="132.1" r="1.5" />
            <circle fill={colors.text} cx="49.2" cy="132.1" r="1.5" />
            <rect x="53.4" y="131.2" fill={colors.text} width="6.6" height="2.2" />
            <rect x="62.8" y="131.2" fill={colors.text} width="6.6" height="2.2" />
          </g>
          <g>
            <path fill={colors.text} d="M55.2,32.6c1-1.2-9.6-12.1-11.5-9.7C41.7,25.3,54.2,33.8,55.2,32.6z" />
          </g>
          <g>
            <path fill={colors.text} d="M66.3,31.7c1.6-0.2,1.7-12.8-1.4-12.4C61.8,19.6,64.7,31.9,66.3,31.7z" />
          </g>
          <g>
            <path fill={colors.text} d="M77.3,32.5c1.3,0.9,10.6-8.7,8.1-10.5C82.9,20,76,31.6,77.3,32.5z" />
          </g>
        </g>
        <g>
          <path
            fill={colors.text}
            d="M306.7,161.9c22,0,42.8-8.9,58.4-25.2c14.1-14.7,21.2-36.8,21-65.7c-0.1-20.2-3.8-36.6-3.9-37.3l-2.5-11.1
		L171.8,11.4l-4.3,9.2c-15.9,34-16.7,74.2-2.1,102.2c9.6,18.4,24.7,30,43.6,33.3c7.1,1.3,13.8,1.8,20,1.8c16.2,0,27.1-4.3,34-8.7
		C276.1,157.4,291.4,161.9,306.7,161.9z"
          />
          <path
            fill={colors.tone[tone].mid}
            d="M181.2,26.9l186.5,10c0,0,13.9,61.1-13.3,89.4c-27.2,28.3-68.3,25.5-92.1,3.3c0,0-9.4,18.9-50.5,11.7
		C170.6,134,159,74.6,181.2,26.9z"
          />
          <path
            fill={colors.tone[tone].dark}
            d="M354.3,126.3c-27.2,28.3-68.3,25.5-92.1,3.3c0,0-9.4,18.9-50.5,11.7c-22-3.8-35.6-22.9-40-46.9
		c11.6,30.9,32,39.5,54.9,38.3c34.1-1.7,30-25.8,30-25.8s18.3,51.6,78.3,23.3c43.1-20.4,32.9-93.2,32.9-93.2S381.5,98,354.3,126.3z"
          />
          <g>
            <path fill={colors.text} d="M337,114.2c0.2-7.2,11.8-7,11.7,0.3C348.6,121.6,336.9,121.3,337,114.2z" />
            <path fill={colors.text} d="M323.2,118.3c0.1-5.5,9.1-5.3,9,0.2C332.1,124,323.2,123.8,323.2,118.3z" />
            <path fill={colors.text} d="M332.7,126.8c0.1-5.9,9.8-5.8,9.6,0.2C342.2,132.9,332.5,132.8,332.7,126.8z" />
          </g>
          <g>
            <path
              fill={colors.text}
              d="M257.7,137.7c-11.4-18.1-11.5-42-0.2-60.2c2.6-4.1,11.8-2.7,8.4,2.7c-9.7,15.6-9.6,36.9,0.2,52.5
			C269,137.1,260.3,141.7,257.7,137.7L257.7,137.7z"
            />
          </g>
          <g>
            <path
              fill={colors.text}
              d="M250.1,78.4c-0.5,5.5,1.2,10.3,5.3,14.1c3.8,3.5,0.8,11.6-3.9,7.2c-6.5-5.9-10-14.6-9.3-23.4
			C242.7,69.9,250.6,73.3,250.1,78.4L250.1,78.4z"
            />
          </g>
          <path
            fill={colors.tone[tone].light}
            d="M367.6,36.9c0,0-98.8,32.2-186.5-10C182.3,26.9,367.6,36.9,367.6,36.9z"
          />
        </g>
        <g id="Layer_2">
          <path
            fill={colors.tone[tone].dark}
            d="M207.8,68.6l0.1,1.4l4.1-0.4l-0.6,0.8l7.2,2l-0.6,0.8l4.3,0.9l-1.3,0.8l2.3,1.8l-1.4,0.1l2.4,9.5
		c1.1,1.3,1.7,2.8,1.9,4.7c0.2,1.8-0.2,3.5-1.2,5l-2.2,8.6c-1.1,2.9-6.1,7.6-10.3,8c-4.1,0.4-10.1-3.1-11.7-5.7l-4-7.9
		c-1.3-1.3-2-2.8-2.2-4.6c-0.2-1.8,0.1-3.5,0.9-5l-1.2-11.7l1.4,0.5l2.3-4.4l0.8,1.3L207.8,68.6z M212,82c-3.9-1.9-7.7-2.7-11.4-2.3
		c-1.7,1.1-2.7,3.3-2.8,6.5l0,0l0.3,9c0.3,2.4,4.1,9.3,4.5,9.9c3.3,4.5,8.9,5,9.6,4.9s6.1-1.7,8.3-6.8c0.3-0.7,2.6-8.3,2.3-10.7
		l-1.2-7.5l-2.2-3.9l-0.6,0.8l-2.9-1.1l0.1,1.4l-3.7-1.7 M203.2,90.6c-1,0.1-1.8,1-1.7,2.1c0.1,1,1,1.8,2.1,1.7c1-0.1,1.8-1,1.7-2.1
		C205.2,91.3,204.2,90.5,203.2,90.6 M216.9,89.2c-1,0.1-1.8,1-1.7,2.1c0.1,1,1,1.8,2.1,1.7c1-0.1,1.8-1,1.7-2.1
		C218.9,89.8,218,89,216.9,89.2 M208.6,99.1l4.8-0.5c0.4,0,0.7,0.2,0.8,0.6c0,0.4-0.2,0.7-0.6,0.8l-4.8,0.5c-0.4,0-0.7-0.2-0.8-0.6
		C207.9,99.5,208.2,99.1,208.6,99.1 M207.8,104.7l7.6-0.8c0.4,0,0.7,0.2,0.8,0.6c0,0.4-0.2,0.7-0.6,0.8l-7.6,0.8
		c-0.4,0-0.7-0.2-0.8-0.6C207.2,105.1,207.4,104.8,207.8,104.7 M199.4,90.5c0.4-0.9,1.1-1.7,2-2c1.1-0.4,2.4-0.2,3.8,0.6
		c0.3,0.2,0.7,0.1,0.9-0.3c0.2-0.3,0.1-0.7-0.3-0.9c-2.2-1.2-3.9-1-4.9-0.7c-1.3,0.5-2.3,1.5-2.8,2.8c-0.1,0.4,0,0.8,0.4,0.9
		c0.1,0,0.2,0,0.3,0C199.1,90.9,199.3,90.7,199.4,90.5z M221.6,88.6c0.2-0.3,0.2-0.7,0-1c-1.4-1.3-2.9-1.8-4.5-1.6
		c-1.2,0.1-2.4,0.7-3.7,1.6c-0.3,0.2-0.4,0.7-0.1,1c0.2,0.3,0.7,0.4,1,0.1c1.1-0.8,2.1-1.3,3-1.4c1.2-0.1,2.3,0.3,3.4,1.3
		c0.2,0.2,0.3,0.2,0.5,0.2C221.3,88.8,221.5,88.7,221.6,88.6z"
          />
        </g>
      </svg>
    </Box>
  )
}
